import {reducers} from './../utils/PlaybackReducers';
import StateRecorder from './../reducers/StateRecorder';

const allReducers = [StateRecorder,...reducers];

export function combineReducers (state, action) {
	return (allReducers.reduce( (prevState, func) => func(prevState, action), state));
}
